import './index.css'

// Inject spin keyframe early (needed before AppShell loads)
const styleEl = document.createElement('style')
styleEl.textContent = '@keyframes spin { to { transform: rotate(360deg); } }'
document.head.appendChild(styleEl)

let booted = false
async function boot(showAuth) {
  if (booted) return
  booted = true

  // Disable both buttons and show loading feedback
  const signInBtn = document.querySelector('header button')
  const ctaBtn = document.querySelector('main button')
  if (signInBtn) { signInBtn.disabled = true; signInBtn.style.opacity = '0.5'; signInBtn.style.pointerEvents = 'none' }
  if (ctaBtn) {
    ctaBtn.disabled = true
    ctaBtn.style.opacity = '0.7'
    ctaBtn.style.pointerEvents = 'none'
    ctaBtn.textContent = 'Loading\u2026'
    // Append small spinner below CTA
    const spinner = document.createElement('div')
    spinner.style.cssText = 'width:20px;height:20px;border:2px solid rgba(245,158,11,0.2);border-top:2px solid #f59e0b;border-radius:50%;animation:spin 0.8s linear infinite;margin:12px auto 0'
    ctaBtn.parentNode.insertBefore(spinner, ctaBtn.nextSibling)
  }

  try {
    const { mount } = await import('./AppShell.jsx')
    mount(showAuth)
  } catch (err) {
    console.error('Failed to load app:', err)

    // Reset buttons so user can retry
    booted = false
    if (signInBtn) { signInBtn.disabled = false; signInBtn.style.opacity = ''; signInBtn.style.pointerEvents = '' }
    if (ctaBtn) {
      ctaBtn.disabled = false
      ctaBtn.style.opacity = ''
      ctaBtn.style.pointerEvents = ''
      ctaBtn.textContent = 'Get Started \u2014 It\u2019s Free'
      const spinner = ctaBtn.nextElementSibling
      if (spinner && spinner.style.animation) spinner.remove()
    }
    // Show error message
    const main = document.querySelector('main')
    if (main && !document.getElementById('boot-error')) {
      const msg = document.createElement('p')
      msg.id = 'boot-error'
      msg.style.cssText = 'color:#ef4444;font-size:14px;margin-top:16px'
      msg.textContent = 'Failed to load. Please check your connection and try again.'
      main.appendChild(msg)
    }
  }
}

window.__boot = boot

// Static HTML "Get Started" just boots the app — AppShell handles anonymous auth
window.__bootAnon = () => boot(false)

// Auto-boot the app after initial paint (don't wait for user click)
const defer = window.requestIdleCallback || ((cb) => setTimeout(cb, 200))
defer(() => boot(false))

// Register service worker (non-blocking, after page load)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
